import { inject } from '@angular/core';
import { CanActivateFn, Params, Router } from '@angular/router';
import { ApiService } from 'src/app/core/services/api.service';
import { normalizeInternalAppRedirect } from 'src/app/core/utils/internal-app-redirect';
import { AuthFlowService } from '../services/auth-flow.service';

/**
 * При F5 / прямом заходе на шаг телефона или онбординга
 * с уже выданным token — сразу в ЛК.
 * Не срабатывает на in-app переходах (код → tel), даже если
 * документ когда‑то был перезагружен.
 */
export const onboardingReloadGuard: CanActivateFn = () => {
  const api = inject(ApiService);
  const router = inject(Router);
  const flow = inject(AuthFlowService);

  if (!api.token) {
    return router.createUrlTree(flow.getBaseCommands(), {
      queryParams: getCurrentQueryParams(router),
    });
  }

  if (!router.navigated) {
    const redirect = normalizeInternalAppRedirect(
      router
        .getCurrentNavigation()
        ?.extractedUrl.queryParamMap.get('redirect'),
    );
    return redirect ? router.parseUrl(redirect) : router.createUrlTree(['/app']);
  }

  return true;
};

function getCurrentQueryParams(router: Router): Params {
  return (
    router.getCurrentNavigation()?.extractedUrl.queryParams ??
    router.parseUrl(router.url).queryParams
  );
}
